export const stringsAreEqual = (firstString = '', secondString = ''): boolean =>
  firstString.localeCompare(secondString, 'pt-br', {
    sensitivity: 'base',
  }) === 0;
